import {
  Avatar,
  Badge,
  Button,
  Carousel,
  Collapse,
  Divider,
  Input,
  message,
  Modal,
  Spin,
  Tooltip,
} from "antd";
import {
  clientMasterData,
  formFields,
  formFieldsSectionTabs,
  sectionsOfForm,
} from "./constants";
import styles from "./styles.module.scss";

import {
  AccordianDropdownArrow,
  AlertWhiteIcon,
  AssistantIcon,
  CalenderIconNew,
  CaseAlertIcon,
  CloseCaseIconRed,
  CustomerNumberIcon,
  DeleteIconRed,
  FileRefrenceIcon,
  FilesTableIcon,
  FormLayoutSwitch,
  InvoiceDateIcon,
  InvoiceNumberIcon,
  OpenCaseIcon,
  PolicyHolderIcon,
  SearchIcon,
  SliderNextIcconNew,
  SliderPreviousIcconNew,
  UpdateCaseIcon,
  UploadFilesRed,
} from "icons";
import { ConditionalRenderer } from "components";
import { ConfirmationPopUp } from "./components/modals";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AttachmentsTable } from "./components/Attachments-table";
import { CarouselSliderBtn } from "components/carouselNextBtn";
import { useEffect, useMemo, useRef, useState } from "react";
import { useCurrentUserContext } from "providers";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { CardOfInputs } from "./components/listOfInputs";
import { SingleInput } from "./components/listOfInputs/singleInput";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { Tabs } from "./components/tabs";
import { AllUploadedFiles } from "./components/all-uploaded-files";
import {
  caseDetailFormAtom,
  caseStatus,
  categoryPopUp,
  excelTableHandlers,
  excelUrlRecoil,
} from "store/atom";
import { useRecoilState } from "recoil";
import { SearchOutlined } from "@ant-design/icons";
import { Notes } from "pages/notes";
import CaseReminder from "./components/case-reminder";
import { CustomerRecordIcon } from "icon-components/CustomerRecordIcon";
import { ListOfAssets } from "icon-components/ListOfAssetsIcon";
import { NotesIcon } from "icon-components/NotesIcon";
import { ReminderIcon } from "icon-components/ReminderIcon";
import { SettingsIcon } from "icon-components/SettingsIcon";
import { FileNumberSmile } from "./components/file-number-smile";
import { Settings } from "./components/settings";
import { SingleFormItemDetail } from "./components/listOfInputs/singleInputHistory";
export const CaseInfo = () => {
  const location = useLocation();
  const { user } = useCurrentUserContext();
  const { origin, popupOrigin, category } = location?.state || {};
  const [isExcelFileChanged, setIsExcelFileChanged] = useState(false);
  const hotRef = useRef(null);
  const [excelHandlers, setExcelHandlers] = useRecoilState(excelTableHandlers);

  const { handleExport, loadExcel } = excelHandlers || {};

  // const [openAlertModal, setOpenAlertModal] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useRecoilState(categoryPopUp);
  const [excelUrlState, setExcelUrlState] = useRecoilState(excelUrlRecoil);
  const [singleCategoryItem, setSingleCategoryItem] = useState();

  const { translator } = useLanguageTranslator();
  const caseDetailTrans = translator("caseDetail");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [openModalCloseCase, setOpenModalCloseCase] = useState(false);
  const [openModalDeleteCase, setOpenModalDeleteCase] = useState(false);
  const { caseId } = useParams();
  const [totalFormData, setTotalFormData] = useState({});
  const [debounceTotalFormData, setDebounceTotalFormData] = useState(null);
  const [formData, setFormData] = useRecoilState(caseDetailFormAtom);
  const [search, setSearch] = useState("");
  const formUpdateRef = useRef(false);
  const [isFileTableActive, setIsFileTableActive] = useState(false);
  const [searchAssets, setSearchAssets] = useState("");
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [carModels, setcarModels] = useState([]);
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);
  const [activeSection, setActiveSection] = useState(formFieldsSectionTabs[0]);
  const [isSectionsLayout, setIsSectionsLayout] = useState(false);
  const [openReminderPopup, setOpenReminderPopup] = useState(false);
  const [showNewTemplate, setShowNewTemplate] = useState(false);
  const reminderTrans = translator("caseDetail.reminder");
  const caseFormTrans = translator("caseDetail.form");
  const [caseStatusLocal, setCaseStatusLocal] = useState();

  const {
    data: caseTotalStatuses,
    isLoading: caseTotalStatusesLoading,
    refetch: refetchcaseTotalStatuses,
  } = UseApiCallV2({
    url: "/get_status",
    method: "POST",
    paramsData: {
      temp: "all",
    },
  });
  // const {
  //   data: excelUrl,
  //   isLoading: excelUrlLoading,
  //   refetch: refetchExcelUrl,
  // } = UseApiCallV2({
  //   url: "/get_xlsx",
  //   method: "POST",
  //   paramsData: {
  //     case_id: caseId,
  //   },
  // });

  // useEffect(() => {
  //   if (excelUrl?.url) {
  //     setExcelUrlState(excelUrl?.url);
  //   }
  // }, [excelUrl?.url]);

  const {
    data: utilityCount,
    isLoading: utilityCountLoading,
    refetch: refetchCount,
  } = UseApiCallV2({
    url: "/utility_count",
    method: "POST",
    paramsData: {
      case_id: caseId,
    },
  });

  const TABS_OF_SCREENS = {
    customerRecord: "customerRecord",
    listOfAssets: "listOfAssets",
    notesTab: "notesTab",
    reminders: "reminders",
    settings: "settings",
  };
  const tabs = [
    {
      title: TABS_OF_SCREENS.customerRecord,
      icon: CustomerRecordIcon,
      showCount: false,
      count: "50%",
    },
    {
      title: TABS_OF_SCREENS.listOfAssets,
      icon: ListOfAssets,
      showCount: true,
      count: utilityCount?.file,
    },
    {
      title: TABS_OF_SCREENS.notesTab,
      icon: NotesIcon,
      showCount: true,
      count: utilityCount?.notes,
    },
    {
      title: TABS_OF_SCREENS.reminders,
      icon: ReminderIcon,
      showCount: true,
      count: utilityCount?.reminders?.["PENDING"],
    },
    { title: TABS_OF_SCREENS.settings, icon: SettingsIcon, showCount: false },
  ];
  const [activeComponent, setActiveComponent] = useState(
    TABS_OF_SCREENS.customerRecord,
  );

  const { data: employeesData, isLoading: employeesLoading } = UseApiCallV2({
    url: "/get_usernames",
    method: "POST",
    paramsData: {
      email: user?.email,
    },
  });
  const employees = useMemo(() => {
    return employeesData?.users?.map((item) => {
      return {
        label: item?.username,
        value: item?.email,
      };
    });
  }, [employeesData?.users]);

  const {
    data: legalDocuments,
    isLoading: legalDocumentsLoading,
    refetch: refetchLegalDocs,
  } = UseApiCallV2({
    url: "/get_all_uploads",
    method: "POST",
    paramsData: {
      case_id: caseId,
    },
  });

  const {
    data: allUploadedFiles,
    isLoading: allUploadedFilesLoading,
    refetch: refetchAllUploadedFiles,
  } = UseApiCallV2({
    url: "/get_overall_uploads",
    method: "POST",
    paramsData: {
      case_id: caseId,
    },
  });

  const {
    data: inssurerCompanies,
    isLoading: inssurerCompaniesLoading,
    refetch: refetchInssurerCompanies,
  } = UseApiCallV2({
    url: "/get_all_companies",
    method: "POST",
    paramsData: {
      type: "company",
    },
  });
  const {
    data: relations,
    isLoading: relationsLoading,
    refetch: refetchrelations,
  } = UseApiCallV2({
    url: "/get_relations",
    method: "POST",
    paramsData: {
      temp: "None",
    },
  });

  const {
    data: allCourts,
    isLoading: allCourtsLoading,
    refetch: refetchallCourts,
  } = UseApiCallV2({
    url: "/get_all_courts",
    method: "POST",
    paramsData: {
      temp: "None",
    },
  });

  const {
    data: countries,
    isLoading: countriesLoading,
    refetch: refetchcountries,
  } = UseApiCallV2({
    url: "/get_countries",
    method: "POST",
    paramsData: {
      temp: "None",
    },
  });

  const {
    data: carCompanies,
    isLoading: carCompaniesLoading,
    refetch: refetchCarCompanies,
  } = UseApiCallV2({
    url: "/get_car_manufacturers",
    method: "POST",
    paramsData: {
      temp: "none",
    },
  });

  const [
    caseHistoryUpdate,
    {
      data: caseHistoryUpdateData,
      isLoading: caseHistoryUpdateLoading,
      error: caseHistoryUpdateError,
    },
  ] = UseLazyApiCallV2({
    url: "/case_history_update",
    method: "POST",
  });
  const [
    getCarModel,
    { data: carModelData, isLoading: carModelLoading, error: carModelError },
  ] = UseLazyApiCallV2({
    url: "/get_car_model",
    method: "POST",
  });
  const {
    data: cities,
    isLoading: citiesDataLoading,
    error: citiesDataError,
    refetch: refetchCities,
  } = UseApiCallV2({
    url: "/get_cities",
    method: "POST",
    paramsData: {
      stateid: 82,
    },
  });
  const {
    data: states,
    isLoading: statesLoading,
    error: statesError,
  } = UseApiCallV2({
    url: "/get_states",
    method: "POST",
    paramsData: {
      countryid: 82,
    },
  });

  const finalCarCompanies = useMemo(() => {
    return carCompanies?.carCompanies?.map((item) => {
      return {
        label: item?.manufacturerName,
        value: item?.id,
      };
    });
  }, [carCompanies?.carCompanies]);

  const finalInssurerCompanies = useMemo(() => {
    return inssurerCompanies?.companies?.map((item) => {
      return {
        label: item?.companyName,
        value: item?.id,
      };
    });
  }, [inssurerCompanies?.companies]);

  const finalRelations = useMemo(() => {
    return relations?.relations?.map((item) => {
      return {
        label: item?.relationType,
        value: item?.id,
      };
    });
  }, [relations?.relations]);
  const finalCourts = useMemo(() => {
    return allCourts?.courts?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    });
  }, [allCourts?.courts]);

  const finalCountries = useMemo(() => {
    return countries?.countries?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    });
  }, [countries?.countries]);
  const finalCities = useMemo(() => {
    return cities?.cities?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    });
  }, [cities?.cities]);
  const finalStates = useMemo(() => {
    return states?.states?.map((item) => {
      return {
        label: item?.name,
        value: item?.id,
      };
    });
  }, [states?.states]);

  const dropdownsListObj = {
    insurer: finalInssurerCompanies,
    carCompany: finalCarCompanies,
    carModel: carModels,
    country: finalCountries,
    city: finalCities,
    state: finalStates,
    competentCourt: finalCourts,
    relationToCustomer: finalRelations,
  };
  const refetchDropdownsListObj = {
    insurer: refetchInssurerCompanies,
    city: refetchCities,
  };

  useEffect(() => {
    const clickedCategory = formData?.find((item) => item.key === category);
    setSingleCategoryItem({ ...clickedCategory });
  }, []);

  useEffect(() => {
    if (popupOrigin && !openAlertModal && singleCategoryItem) {
      setOpenAlertModal(true);
    }
  }, [singleCategoryItem]);

  useEffect(() => {
    if (activeSection && isSectionsLayout) {
      const filteredFields = formData;
    } else {
    }
  }, [activeSection]);

  useEffect(() => {
    getCarModelOptions({ id: totalFormData?.carCompany_id });
  }, [totalFormData?.carCompany]);

  function handleClickTab(item) {
    setCollapseOpen(false);
    setActiveComponent(item.title);
    // sliderRef.current.goTo(slidesToIndex?.[item.title]);
  }

  // useEffect(() => {
  //   getCitiesOptions({ id: totalFormData?.country_id });
  // }, [totalFormData?.country]);

  async function getCarModelOptions({ id }) {
    if (!id) return;
    try {
      const data = await getCarModel({
        params: {
          manufacturerid: id,
        },
      });
      const final = data?.carCompanies?.map((item) => ({
        label: item?.modelName,
        value: item?.id,
      }));
      setcarModels([...final]);
    } catch (error) {}
  }

  // async function getCitiesOptions({ id }) {
  //   if (!id) return;

  //   try {
  //     const data = await getCities({
  //       params: {
  //         countryid: id,
  //       },
  //     });

  //     const final = data?.states?.map((item) => ({
  //       label: item?.name,
  //       value: item?.id,
  //     }));
  //     setcities([...final]);
  //   } catch (error) {}
  // }

  const tabsArr = [
    {
      title: translator("caseDetail.legalDocs.heading"),
      key: "legalDocs",
    },
    {
      title: translator("caseDetail.legalDocs.allUploadedFilesHeading"),
      key: "allUploadedFiles",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabsArr[0].key);

  const addedWidthGermanLabel = useMemo(() => {
    return formFields?.map((item) => ({
      ...item,
      germanLabel: translator(`caseDetail.form.${item.key}`),
      dropdownList: dropdownsListObj[item?.dropdownType],
      refetchList: refetchDropdownsListObj[item?.dropdownType],
    }));
  }, [
    formFields,
    translator,
    inssurerCompanies,
    allCourts,
    cities,
    countries,
    carCompanies,
    carModels,
  ]);

  useEffect(() => {}, []);

  useEffect(() => {
    const filtered = addedWidthGermanLabel?.filter((item) =>
      item?.germanLabel?.toLowerCase().includes(search?.toLowerCase()),
    );
    if (activeSection && isSectionsLayout) {
      const filteredSectionItems = filtered?.filter((item) =>
        sectionsOfForm?.[activeSection]?.includes(item.key),
      );
      setFormData([...filteredSectionItems]);
    } else {
      setFormData([...filtered]);
    }
  }, [search, addedWidthGermanLabel, activeSection]);

  useEffect(() => {
    setTimeout(() => {
      setDebounceTotalFormData({ ...totalFormData });
    }, 500);
  }, [totalFormData]);

  const navigate = useNavigate();

  const [
    updateCase,
    {
      data: updateCaseData,
      isLoading: updateCaseLoading,
      error: uploadingVideoError,
    },
  ] = UseLazyApiCallV2({
    url: "/update_case_details",
    method: "POST",
  });
  const [
    deleteCase,
    {
      data: deleteCaseData,
      isLoading: deleteCaseLoading,
      error: deleteCaseErr,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_case",
    method: "POST",
  });
  const [
    closeCase,
    { data: closeCaseData, isLoading: closeCaseLoading, error: closeCaseErr },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  const isEditCase = !!caseId;
  const sliderRef = useRef();
  const {
    data: caseDetail,
    isLoading: caseDetailLoading,
    refetch: refetchDetail,
  } = UseApiCallV2({
    url: "/get_case_details",
    method: "POST",
    paramsData: {
      case_id: caseId,
    },
  });

  useEffect(() => {
    setCaseStatusOpenOrClosed(caseDetail?.caseStatus);
  }, [caseDetail?.caseStatus]);

  useEffect(() => {
    if (origin === "upload") {
      sliderRef.current.goTo(1);
    } else if (origin === "notes") {
      sliderRef.current.goTo(2);
    } else {
      return;
    }
  }, [location]);

  useEffect(() => {
    if (caseDetail) {
      setTotalFormData({
        ...caseDetail?.caseDetails,
        FileReferenceSmile: caseId,
      });
    }
  }, [caseDetail, caseId]);

  useEffect(() => {
    if (caseDetail) {
      setTotalFormData((prev) => {
        // Start with caseDetail data + FileReferenceSmile
        const updated = {
          ...caseDetail?.caseDetails,
          FileReferenceSmile: caseId,
        };

        // Loop through fields to hardcode country
        formFields.forEach((field) => {
          // If parent has sections with childs
          if (field.sections) {
            field.sections.forEach((section) => {
              section.childs.forEach((child) => {
                if (child.dropdownType === "country") {
                  updated[child.key] = "Deutschland";
                }
              });
            });
          }

          // If it's a direct child without sections
          if (field.dropdownType === "country") {
            updated[field.key] = "Deutschland";
          }
        });

        return updated;
      });
    }
  }, [caseDetail, caseId, formFields, openAlertModal]);

  useEffect(() => {
    setCaseStatusLocal(caseDetail?.caseStatus);
  }, [caseDetail?.caseStatus]);

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const handlePrev = () => sliderRef?.current?.prev();

  const handleNext = () => sliderRef?.current?.next();

  function handleOpenCloseCaseModal() {
    setOpenModalCloseCase(true);
  }
  function handleOpenDeleteCaseModal() {
    setOpenModalDeleteCase(true);
  }
  const handleGoToSecond = () => {
    sliderRef?.current?.goTo(1, true);
  };
  function handleCloseDeleteCaseModal() {
    setOpenModalDeleteCase(false);
  }
  function handleCloseCloseCaseModal() {
    setOpenModalCloseCase(false);
  }

  function handleChangeLayout() {
    setIsSectionsLayout((prev) => !prev);
  }
  function handleOpenReminderPopup() {
    // setOpenReminderPopup(true);
  }
  function handleCloseReminderPopup() {
    setOpenReminderPopup(false);
  }

  async function onConfirmSaveExcel() {
    await handleExport("save");
    setOpenAlertModal(false);
  }
  async function onConfirmCancelExcel() {
    await loadExcel();
    setOpenAlertModal(false);
  }
  function handleCloseAlert(saveExcelFile) {
    if (!isExcelFileChanged) {
      setOpenAlertModal(false);
      if (popupOrigin === "reminders") {
        navigate("/cases");
      }
      return;
    }

    Modal.confirm({
      title: "Unsaved Changes",
      content: "You have unsaved changes. Do you want to save them?",
      okText: "Save",
      cancelText: "Don't Save",
      onOk: onConfirmSaveExcel,
      onCancel: onConfirmCancelExcel,
    });

    setOpenAlertModal(true);
  }
  useEffect(() => {
    if (debounceTotalFormData && !formUpdateRef.current) {
      setTimeout(() => {
        formUpdateRef.current = true;
      }, 1100);
    }
  }, [debounceTotalFormData]);

  async function handleUpdateCase(key, value) {
    let payload = { ...totalFormData };
    if (key) {
      payload = { ...totalFormData, [key]: value };
    }
    if (Object.keys(payload)?.length < 1) {
      return;
    }
    const params = {
      case_id: caseId,
      caseDetails: { ...payload },
      loggedUser: user?.email,
    };

    try {
      const paramsForHistoryUpdate = {
        query: { ...payload },
        case_id: caseId,
        is_manual: true,
        key_updated: null,
        loggedUser: user?.email,
      };
      await caseHistoryUpdate({
        params: paramsForHistoryUpdate,
      });
      refetchCount();
    } catch (error) {
      console.log({ error });
    }
    try {
      const res = await updateCase({
        params,
      });
      if (res) {
        setFormData((prev) =>
          prev?.map((item) => ({ ...item, active: false })),
        );
      }
      refetchDetail();
      // if (res?.status === "SUCCESS") {
      //   message.success(res?.message);
      // }
    } catch (error) {}
  }

  const icons = [
    // {
    //   icon: CaseAlertIcon,
    //   key: "reminderIcon",
    //   handleClick: handleOpenReminderPopup,
    //   height: 22,
    //   width: 22,
    // },
    {
      icon: FormLayoutSwitch,
      key: "layoutSwitch",
      handleClick: handleChangeLayout,
      height: 22,
      width: 22,
    },
    // {
    //   icon: UploadFilesRed,
    //   key: "uploadFilesKey",
    //   handleClick: handleGoToSecond,
    //   height: 22,
    //   width: 22,
    // },
    // {
    //   icon:
    //     caseDetail?.caseStatus === "pending" ? CloseCaseIconRed : OpenCaseIcon,
    //   key: caseDetail?.caseStatus === "closed" ? "openCase" : "closeCase",
    //   handleClick: handleOpenCloseCaseModal,
    //   height: 25,
    //   width: 25,
    // },
    // {
    //   icon: DeleteIconRed,
    //   key: "deleteCase",
    //   handleClick: handleOpenDeleteCaseModal,
    //   height: 22,
    //   width: 22,
    // },
  ];

  async function handleDeleteCase() {
    try {
      const res = await deleteCase({ params: { case_id: caseId } });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        handleCloseDeleteCaseModal();
        navigate("/cases");
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      console.log({ error });
    }
  }

  async function handleCloseCase() {
    try {
      const res = await closeCase({
        params: {
          case_id: caseId,
          status: caseDetail?.caseStatus === "closed" ? "pending" : "closed",
          loggedUser: user?.email,
        },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        handleCloseCloseCaseModal();
        await refetchDetail();
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      console.log({ error });
    }
  }
  const tableHeading = (
    <h3>
      {isFileTableActive
        ? translator("caseDetail.legalDocs.allUploadedFilesHeading")
        : translator("caseDetail.legalDocs.heading")}
    </h3>
  );

  function clickedItem(item) {
    setSingleCategoryItem(item);
    setOpenAlertModal(true);
  }

  return (
    <div className={styles.casesInfo}>
      <div className={styles.tabsWrapper}>
        {tabs.map((item) => (
          <div
            key={item.title}
            className={`${styles.singleTab} ${
              activeComponent === item.title ? styles.active : ""
            }`}
            onClick={() => handleClickTab(item)}
          >
            <item.icon
              fill={activeComponent === item.title ? "#cd2a3f" : "#B1B4B7"}
            />
            <div className={styles.title}>
              {caseDetailTrans[item.title]}
              <ConditionalRenderer condition={item?.showCount}>
                <div
                  className={`${styles.number} ${
                    activeComponent === item.title ? styles.activeNumber : ""
                  }`}
                >
                  {item.count}
                </div>
              </ConditionalRenderer>
              <ConditionalRenderer
                condition={item.title === TABS_OF_SCREENS.customerRecord}
              >
                <Badge
                  color={activeComponent === item.title ? "#cd2a3f" : "#b1b4b7"}
                  count={`${utilityCount?.percentage}%`}
                  className={`${styles.badge}`}
                ></Badge>
              </ConditionalRenderer>
            </div>
          </div>
        ))}
      </div>

      <Spin spinning={!!(caseDetailLoading || deleteCaseLoading)}>
        {/* <div className={styles.clientMasterSheet}>
          {clientMasterData?.map((item) => (
            <div className={styles.wrapper} key={item.key}>
              <SingleInput
                item={item}
                totalFormData={totalFormData}
                setTotalFormData={setTotalFormData}
                handleUpdateCase={handleUpdateCase}
              />
            </div>
          ))}
        </div> */}
        {/* <ConditionalRenderer
          condition={currentSlide === 0 || currentSlide === 1}
        >
          <CarouselSliderBtn
            Icon={SliderNextIcconNew}
            handleClickBtn={handleNext}
            variant="next"
          />
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={currentSlide === 1 || currentSlide === 2}
        >
          <CarouselSliderBtn
            Icon={SliderPreviousIcconNew}
            handleClickBtn={handlePrev}
            variant="prev"
          />
        </ConditionalRenderer> */}
        <ConditionalRenderer
          condition={activeComponent === TABS_OF_SCREENS.customerRecord}
        >
          <div className={styles.header}>
            <FileNumberSmile
              caseTotalStatuses={caseTotalStatuses?.items}
              caseStatus={caseDetail?.caseStatus}
              caseStatusLocal={caseStatusLocal}
              setCaseStatusLocal={setCaseStatusLocal}
            />
            <ConditionalRenderer condition={isEditCase}>
              <div className={styles.icons}>
                <ConditionalRenderer condition={currentSlide === 0}>
                  <div className={styles.searchContainer}>
                    <Input
                      type="text"
                      placeholder={translator("Search")}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      style={{ width: "346px" }}
                      prefix={<SearchIcon height={15} width={15} />}
                      maxLength={40}
                    />
                  </div>
                </ConditionalRenderer>
                {icons.map((item) => (
                  <Tooltip title={translator(`caseDetail.${item?.key}`)}>
                    <div
                      className={styles.iconContainer}
                      onClick={item.handleClick}
                      style={{
                        display:
                          item.key === "layoutSwitch" && currentSlide !== 0
                            ? "none"
                            : "flex",
                      }}
                    >
                      <ConditionalRenderer
                        condition={item.key === "reminderIcon"}
                      >
                        <div className={styles.remindersCount}>4</div>
                      </ConditionalRenderer>
                      <item.icon
                        style={{ height: item.height, width: item.width }}
                      />
                    </div>
                  </Tooltip>
                ))}
              </div>
            </ConditionalRenderer>
          </div>
          <Collapse
            onChange={() => setCollapseOpen((prev) => !prev)}
            style={{ margin: "0px 15px 0px 15px" }}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <AccordianDropdownArrow
                style={{
                  fontSize: "16px",
                  color: "#1890ff",
                  transform: isActive ? "rotate(0)" : "rotate(180deg)",
                }}
              />
            )}
          >
            <Collapse.Panel
              header={<h3>Referenzangaben</h3>}
              className={styles.panel}
            >
              <div className={styles.clientMasterData}>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={clientMasterData?.slice(0, 5)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    removeBg
                    clickedItem={clickedItem}
                    dropdownsListObj={dropdownsListObj}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={clientMasterData?.slice(5, 10)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    removeBg
                    clickedItem={clickedItem}
                    dropdownsListObj={dropdownsListObj}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={clientMasterData?.slice(10, 15)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    removeBg
                    clickedItem={clickedItem}
                    dropdownsListObj={dropdownsListObj}
                  />
                </div>
              </div>
            </Collapse.Panel>
          </Collapse>

          <div
            className={`${styles.detailModal} ${
              !collapseOpen ? styles.extendHeight : ""
            }`}
          >
            <ConditionalRenderer condition={isSectionsLayout}>
              <div>
                <div className={styles.formFieldsSections}>
                  {formFieldsSectionTabs?.map((item) => (
                    <div
                      className={styles.singleSection}
                      key={item}
                      style={{
                        borderBottom:
                          activeSection === item ? "2px solid #cd2a3f" : "",
                      }}
                      onClick={() => setActiveSection(item)}
                    >
                      {translator(`caseDetail.form.${item}`)}
                    </div>
                  ))}
                </div>
                <div
                  className={`${styles.sectionFields}  ${
                    !collapseOpen ? styles.extendHeightSection : ""
                  }`}
                >
                  <CardOfInputs
                    list={formData}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    variant="section"
                    clickedItem={clickedItem}
                  />
                </div>
              </div>
            </ConditionalRenderer>
            <ConditionalRenderer condition={!isSectionsLayout}>
              <div className={styles.columns}>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(0, 16)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    clickedItem={clickedItem}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(16, 32)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    clickedItem={clickedItem}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(32, 48)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    clickedItem={clickedItem}
                  />
                </div>
              </div>
            </ConditionalRenderer>
          </div>
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={activeComponent === TABS_OF_SCREENS.listOfAssets}
        >
          <div>
            <div className={`${styles.tableSwitchContainer} `}>
              <div>
                <FileNumberSmile
                  caseTotalStatuses={caseTotalStatuses?.items}
                  caseStatus={caseDetail?.caseStatus}
                  caseStatusLocal={caseStatusLocal}
                  setCaseStatusLocal={setCaseStatusLocal}
                />
              </div>
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <ConditionalRenderer condition={!isFileTableActive}>
                  <div>
                    <Input
                      type="text"
                      placeholder={translator("Search")}
                      onChange={(e) => setSearchAssets(e.target.value)}
                      style={{ width: "346px", height: "39px" }}
                      prefix={<SearchIcon height={15} width={15} />}
                      value={searchAssets}
                      maxLength={40}
                    />
                  </div>
                </ConditionalRenderer>
                <button
                  className={isFileTableActive ? styles.isActiveBtn : ""}
                  onClick={() => setIsFileTableActive((prev) => !prev)}
                >
                  <FormLayoutSwitch height={22} width={22} />
                </button>
              </div>
            </div>
            <ConditionalRenderer condition={!isFileTableActive}>
              <AttachmentsTable
                refetchDetail={refetchDetail}
                isLoading={legalDocumentsLoading}
                legalDocuments={legalDocuments}
                refetchLegalDocs={refetchLegalDocs}
                searchAssets={searchAssets}
                refetchAllUploadedFiles={refetchAllUploadedFiles}
                dropdownsListObj={dropdownsListObj}
                tableHeading={tableHeading}
                refetchCount={refetchCount}
              />
            </ConditionalRenderer>
            <ConditionalRenderer condition={isFileTableActive}>
              <AllUploadedFiles
                refetchDetail={refetchDetail}
                isLoading={allUploadedFilesLoading}
                legalDocuments={allUploadedFiles?.documents}
                refetchAllUploadedFiles={refetchAllUploadedFiles}
                refetchLegalDocs={refetchLegalDocs}
                tableHeading={tableHeading}
                refetchCount={refetchCount}
              />
            </ConditionalRenderer>
          </div>
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={activeComponent === TABS_OF_SCREENS.notesTab}
        >
          <Notes
            refetchCount={refetchCount}
            caseTotalStatuses={caseTotalStatuses?.items}
            caseStatus={caseDetail?.caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={activeComponent === TABS_OF_SCREENS.reminders}
        >
          <CaseReminder
            caseId={caseId}
            showNewTemplate={showNewTemplate}
            setShowNewTemplate={setShowNewTemplate}
            employees={employees}
            refetchCount={refetchCount}
            caseTotalStatuses={caseTotalStatuses?.items}
            caseStatus={caseDetail?.caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
        </ConditionalRenderer>
        <ConditionalRenderer
          condition={activeComponent === TABS_OF_SCREENS.settings}
        >
          <Settings
            caseDetail={caseDetail}
            refetchDetail={refetchDetail}
            case_id={caseId}
            utilityCount={utilityCount}
            caseTotalStatuses={caseTotalStatuses?.items}
            caseStatus={caseDetail?.caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
        </ConditionalRenderer>
        {/* <Carousel
          dots={false}
          ref={sliderRef}
          infinite={false}
          className={styles.carouselContainer}
          beforeChange={handleBeforeChange}
        >
          <div
            className={`${styles.detailModal} ${
              !collapseOpen ? styles.extendHeight : ""
            }`}
          >
            <ConditionalRenderer condition={isSectionsLayout}>
              <div>
                <div className={styles.formFieldsSections}>
                  {formFieldsSectionTabs?.map((item) => (
                    <div
                      className={styles.singleSection}
                      key={item}
                      style={{
                        borderBottom:
                          activeSection === item ? "2px solid #cd2a3f" : "",
                      }}
                      onClick={() => setActiveSection(item)}
                    >
                      {translator(`caseDetail.form.${item}`)}
                    </div>
                  ))}
                </div>
                <div
                  className={`${styles.sectionFields}  ${
                    !collapseOpen ? styles.extendHeightSection : ""
                  }`}
                >
                  <CardOfInputs
                    list={formData}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                    variant="section"
                  />
                </div>
              </div>
            </ConditionalRenderer>
            <ConditionalRenderer condition={!isSectionsLayout}>
              <div className={styles.columns}>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(0, 16)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(16, 32)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                  />
                </div>
                <div className={styles.firstColumn}>
                  <CardOfInputs
                    list={formData?.slice(32, 48)}
                    totalFormData={totalFormData}
                    setTotalFormData={setTotalFormData}
                    handleUpdateCase={handleUpdateCase}
                    dropdownsListObj={dropdownsListObj}
                    refetchDropdownsListObj={refetchDropdownsListObj}
                    updateCaseLoading={updateCaseLoading}
                    caseHistoryUpdateLoading={caseHistoryUpdateLoading}
                  />
                </div>
              </div>
            </ConditionalRenderer>
          </div>
          <div>
            <div className={`${styles.tableSwitchContainer} `}>
              <h3>
                {isFileTableActive
                  ? translator("caseDetail.legalDocs.allUploadedFilesHeading")
                  : translator("caseDetail.legalDocs.heading")}
              </h3>
              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <ConditionalRenderer condition={!isFileTableActive}>
                  <div>
                    <Input
                      placeholder={"Search"}
                      onChange={(e) => setSearchAssets(e.target.value)}
                      prefix={<SearchOutlined />}
                      style={{ height: "40px", width: "345px" }}
                      // value={filterInput}
                    />
                  </div>
                </ConditionalRenderer>
                <button
                  className={isFileTableActive ? styles.isActiveBtn : ""}
                  onClick={() => setIsFileTableActive((prev) => !prev)}
                >
                  <FilesTableIcon />
                </button>
              </div>
            </div>
            <ConditionalRenderer condition={!isFileTableActive}>
              <AttachmentsTable
                refetchDetail={refetchDetail}
                isLoading={legalDocumentsLoading}
                legalDocuments={legalDocuments}
                refetchLegalDocs={refetchLegalDocs}
                searchAssets={searchAssets}
                refetchAllUploadedFiles={refetchAllUploadedFiles}
                dropdownsListObj={dropdownsListObj}
                collapseOpen={collapseOpen}
              />
            </ConditionalRenderer>
            <ConditionalRenderer condition={isFileTableActive}>
              <AllUploadedFiles
                refetchDetail={refetchDetail}
                isLoading={allUploadedFilesLoading}
                legalDocuments={allUploadedFiles?.documents}
                refetchAllUploadedFiles={refetchAllUploadedFiles}
                refetchLegalDocs={refetchLegalDocs}
                collapseOpen={collapseOpen}
              />
            </ConditionalRenderer>
          </div>
          <Notes collapseOpen={collapseOpen} />
        </Carousel> */}
        <ConfirmationPopUp
          Icon={DeleteIconRed}
          title={translator("deleteCase")}
          description={translator("confirmationForDeleteCase")}
          open={openModalDeleteCase}
          onClose={handleCloseDeleteCaseModal}
          onConfirm={handleDeleteCase}
        />
        <ConfirmationPopUp
          Icon={
            caseDetail?.caseStatus === "pending"
              ? CloseCaseIconRed
              : OpenCaseIcon
          }
          title={
            caseDetail?.caseStatus === "pending"
              ? translator("closeCase")
              : translator("openCase")
          }
          description={
            caseDetail?.caseStatus === "pending"
              ? translator("confirmationForCloseCase")
              : translator("confirmationForOpenCase")
          }
          open={openModalCloseCase}
          onClose={handleCloseCloseCaseModal}
          onConfirm={handleCloseCase}
        />
      </Spin>
      <Modal
        destroyOnClose
        open={openReminderPopup}
        onCancel={handleCloseReminderPopup}
        footer={null}
        title={showNewTemplate ? "Add Template" : "Set Reminder"}
        centered
        width="100dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            borderRadius: "20px",
            height: "97dvh",
            overflowY: "auto",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <CaseReminder
          caseId={caseId}
          showNewTemplate={showNewTemplate}
          setShowNewTemplate={setShowNewTemplate}
        />
      </Modal>
      <Modal
        destroyOnClose
        open={openAlertModal}
        onCancel={handleCloseAlert}
        footer={null}
        centered
        width="100dvw"
        styles={{
          content: {
            backgroundColor: "#F5F6F8",
            borderRadius: "20px",
            height: "97dvh",
            padding: "5px 0px 0px 10px",
          },
          header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
        }}
      >
        <SingleFormItemDetail
          handleCloseAlert={handleCloseAlert}
          caseItemData={singleCategoryItem}
          entryName={singleCategoryItem?.key}
          reminderTrans={reminderTrans}
          caseFormTrans={caseFormTrans}
          item={singleCategoryItem}
          totalFormData={totalFormData}
          setTotalFormData={setTotalFormData}
          handleUpdateCase={handleUpdateCase}
          dropdownsListObj={dropdownsListObj}
          refetchDropdownsListObj={refetchDropdownsListObj}
          updateCaseLoading={updateCaseLoading}
          caseHistoryUpdateLoading={caseHistoryUpdateLoading}
          refetchDetail={refetchDetail}
          setIsExcelFileChanged={setIsExcelFileChanged}
          isExcelFileChanged={isExcelFileChanged}
          // tableData={tableData}
        />
      </Modal>
    </div>
  );
};
